module.exports = __webpack_public_path__ + "img/header-diamondJewelryExclusive@2x.5a28a88.jpg";